import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { RetrievalProgressState } from '../types';

/**
 * 检索进度模型
 * @description 存储检索进度状态
 */
export interface FtoReportRetrievalProgressModel extends Model<RetrievalProgressState>, Disposable {

}

export const FtoReportRetrievalProgressModel = Symbol.for('FtoReportRetrievalProgressModel');
